import {
	MOVE_TO_TOP,
	MOVE_UP,
	MOVE_DOWN,
	MOVE_TO_BOTTOM,
	BEFORE,
	AFTER,
	type MenuItemReorderOperation,
} from './constants.tsx';

type ProjectId = string;

export const moveToTop = (projectsList: ProjectId[], projectId: ProjectId) => {
	const filteredList = projectsList.filter((id) => id !== projectId);
	return [projectId, ...filteredList];
};

export const moveToBottom = (projectsList: ProjectId[], projectId: ProjectId) => {
	const filteredList = projectsList.filter((id) => id !== projectId);
	return [...filteredList, projectId];
};

export const moveUp = (projectsList: ProjectId[], projectId: ProjectId) => {
	const index = projectsList.indexOf(projectId);
	if (index > 0) {
		const newList = [...projectsList];
		newList.splice(index, 1);
		newList.splice(index - 1, 0, projectId);
		return newList;
	}
	return projectsList;
};

export const moveDown = (projectsList: ProjectId[], projectId: ProjectId) => {
	const index = projectsList.indexOf(projectId);
	if (index >= 0) {
		const newList = [...projectsList];
		newList.splice(index, 1);
		newList.splice(index + 1, 0, projectId);
		return newList;
	}
	return projectsList;
};

export const insertBefore = (
	projectsList: ProjectId[],
	projectId: ProjectId,
	relativeProject: ProjectId,
) => {
	const index = projectsList.indexOf(relativeProject);
	if (index >= 0) {
		const filteredList = projectsList.filter((id) => id !== projectId);
		const newList = [...filteredList];
		newList.splice(filteredList.indexOf(relativeProject), 0, projectId);
		return newList;
	}
	return projectsList;
};

export const insertAfter = (
	projectsList: ProjectId[],
	projectId: ProjectId,
	relativeProject: ProjectId,
) => {
	const index = projectsList.indexOf(relativeProject);
	if (index >= 0) {
		const filteredList = projectsList.filter((id) => id !== projectId);
		const newList = [...filteredList];
		newList.splice(filteredList.indexOf(relativeProject) + 1, 0, projectId);
		return newList;
	}
	return projectsList;
};

export const insertAtTop = (projectsList: ProjectId[], projectId: ProjectId) => {
	return [projectId, ...projectsList];
};

export const insertAtBottom = (projectsList: ProjectId[], projectId: ProjectId) => {
	return [...projectsList, projectId];
};

export const reorder = (
	operation: MenuItemReorderOperation,
	projectIds: ProjectId[],
	projectId: ProjectId,
	relativeId?: ProjectId,
) => {
	switch (operation) {
		case MOVE_TO_TOP:
			return moveToTop(projectIds, projectId);
		case MOVE_UP:
			return moveUp(projectIds, projectId);
		case MOVE_DOWN:
			return moveDown(projectIds, projectId);
		case MOVE_TO_BOTTOM:
			return moveToBottom(projectIds, projectId);
		case BEFORE:
			return relativeId ? insertBefore(projectIds, projectId, relativeId) : projectIds;
		case AFTER:
			return relativeId ? insertAfter(projectIds, projectId, relativeId) : projectIds;
		default:
			return projectIds;
	}
};
